<template>
	
	<div class="layout-topbar">
		<div class="p-grid p-ai-center">
			
			<div class="p-col">
				<button class="p-link layout-menu-button" @click="onMenuToggle" v-if="userLogado">
					<span class="pi pi-bars"></span>
				</button>

				<div class="layout-topbar-icons" v-if="!userLogado">
					<button class="p-link" v-tooltip.bottom="'Entrar'" @click="onLogin()">
						<span class="layout-topbar-item-text">User</span>
						<span class="layout-topbar-icon pi pi-user" ></span>
					</button>
				</div>	
			</div>
			
			<div class="p-col p-offset-4 p-md-offset-9 dropdown">				
				<i class="pi pi-question-circle " style="fontSize:2rem;">
				</i>
				<span style="margin-left:0.4rem;font-size:1rem;vertical-align:super;font-family:Arial;font-weight:bold">Ajuda</span>					
				<div class="dropdown-content">
					<!--<a class="link-text" style="font-family:Arial;cursor:pointer" @click="downloadManual()">Manual de Uso</a> -->
					<a class="link-text" style="font-family:Arial;cursor:pointer" :href="'http://201.49.166.151/pydio/data/public/recadastramento'" target="_BLANK">Manual de Uso</a>
					<!-- <a class="link-text" style="font-family:Arial;cursor:pointer" :href="'/assets/MANUAL_RECADASTRAMENTO 2021_v1.1.pdf'" target="_BLANK">Manual de Uso</a> -->
					<a class="link-text" style="font-family:Arial;cursor:pointer" @click="redirecionamento('RECADFAQ_MENU')">FAQ</a>
					<a class="link-text" style="font-family:Arial;cursor:pointer" @click="redirecionamento('RECADFALECONOSCO_MENU')">Fale Conosco</a>
				</div>								
			</div>

		</div>
	</div>	
</template>

<script>
import { mapState } from 'vuex';
export default {
	computed: mapState(['userLogado']), 
    methods: {
        onMenuToggle(event) {
            this.$emit('menu-toggle', event);
		},
		onLogin(){
			this.$router.push({name:"recadastramento"})
		},
		redirecionamento(nome){
			if(nome != this.$route.name) {
				this.$router.push({name:nome})
			}
		},
		downloadManual(){

			//http://201.49.166.151/pydio/data/public/manualrecadastramento
			
		}
		
    }
}
</script>

<style>
	.dropdown {
	position: relative;
	display: inline-block;
	text-align: center;
	}

	.dropdown-content {
		display: none;
		position: absolute;
		right: 0;
		background-color: #f9f9f9;
		min-width: 160px;
		box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
		z-index: 1;
	}

	.dropdown-content a {
		color: black;
		padding: 12px 16px;
		text-decoration: none;
		display: block;
		text-align: left;
	}

	.dropdown:hover .dropdown-content {
		display: block;
	}

	.dropdown-content a:hover {background-color: #f1f1f1;}

	.link-text{
		font-size: 1rem;
	}
</style>